import React, { useState, useEffect } from "react";
import "./SectionSevenMobile.css";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { FAQ_API } from "../../../constants/api";

function SectionSevenMobile() {
  const [expanded, setExpanded] = useState("panel-1");
  const [faqs, setFaqs] = useState(null);

  useEffect(() => {
    const getFaqs = async () => {
      const response = await fetch(FAQ_API + "/list");
      const faq = await response.json();

      if (response.ok) {
        setFaqs(faq.data);
        setExpanded(faq.data[faq.data.length - 5]._id);
      }
    };

    getFaqs();
  }, []);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleBookCall = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div id="section-seven-mobile" className="section-seven-mobile d-flex">
      <div className="container align-self-center">
        <div className="row d-flex justify-content-center">
          <div className="col-md-10">
            <h1 className="text-center fs-1 fw-bold section-seven-heading">
              We Got You Covered
            </h1>
          </div>
        </div>

        <div className="row mt-4 d-flex justify-content-center">
          <div className="col-md-10">
            <div className="row">
              <div className="col-lg-6 sec-seven-col-mobile p-2 "> 
                <div className="sec-seven-card-1 p-4 d-flex flex-wrap overflow-auto align-items-center">
                  <div className="container-fluid">
                    {faqs &&
                      faqs.slice(faqs.length - 5, faqs.length).map((faq) => (
                        <Accordion
                          key={faq._id}
                          expanded={expanded === faq._id}
                          onChange={handleChange(faq._id)}
                          className="section-seven-accordion"
                        >
                          <AccordionSummary
                            className="section-seven-accordion-summary"
                            expandIcon={<ExpandMoreIcon />}
                          >
                            <Typography style={{fontSize: "14px"}} className="section-seven-accordion-question fw-bold">
                              {faq.question}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography style={{fontSize: "14px"}} className="section-seven-accordion-answer">
                              {faq.answer}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                  </div>
                </div>
              </div>

              <div className="col-lg-6 sec-seven-col p-2 d-none d-lg-flex d-xl-flex align-items-center">
                <div className="sec-seven-card-2 shadow p-4 container-fluid d-flex flex-column gap-2 justify-content-center">
                  <div className="row">
                    <div className="col-12 sec-seven-card-2-col-1 d-flex align-items-center justify-content-end">
                      <img
                        src="/media/section-six-phone.svg"
                        className="section-seven-image"
                        alt=""
                      />
                    </div>
                    <div className="col-12 sec-seven-card-2-col-2 d-flex align-items-end">
                      <h1 className="section-seven-cta-heading text-white">
                        Book a <br /> Call
                      </h1>
                    </div>
                    <div className="col-12 sec-seven-card-2-col-3 d-flex align-items-center">
                      <button
                        onClick={() =>
                          handleBookCall(
                            "https://calendly.com/hypeappstore/30min"
                          )
                        }
                        className="btn section-seven-cta"
                      >
                        Book a call
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionSevenMobile;
